import type { Week, DeliveryKbnRadioItem } from "./types";

/** 画面名定数。 */
export const DELIVERY_MOVE_REGISTER_FILE_NAME = "RegistrationDeliveryMove";

/** 曜日配列。 */
export const WEEKS: Week[] = ['日', '月', '火', '水', '木', '金', '土'];

/** 配達区分ラジオボタン項目。 */
export const DELIVERY_KBN_RADIO_ITEMS: DeliveryKbnRadioItem[] = [
  { item: '在庫移動', index: 1 },
  { item: '回収登録', index: 2 }
];
